// @ts-expect-error: @rails/request.js is not typed
import { FetchRequest } from '@rails/request.js'
import { useMutation } from '@tanstack/react-query'

import { GrapeAPIError, type GrapeAPIErrorType } from './GrapeAPIError'
import { type GenerateQuoteFormProps, type Quote } from '../prospects/types'

export function useGenerateQuote ({
  prospectId,
  quoteId,
}: {
  prospectId: string;
  quoteId: string;
}) {
  return useMutation<Quote, GrapeAPIErrorType, GenerateQuoteFormProps>({
    mutationFn: async (data: GenerateQuoteFormProps) => {
      const request = new FetchRequest(
        'post',
        `/api/web/quoting/prospects/${prospectId}/quotes/${quoteId}/generate`,
        {
          headers: {
            Accept: 'application/json',
          },
          body: data,
        }
      )
      const response = await request.perform()
      if (!response.ok) {
        const errors = await response.json
        throw GrapeAPIError({
          status: response.status,
          message: errors.message,
          errors: errors.errors,
        })
      }
      return response.json
    },
  })
}
